import { TipoModalEnum } from "./TipoModalEnum";

export class DadosModal {
  aberto: boolean;
  titulo: string;
  mensagem: string;
  largura: string;
  tipo: TipoModalEnum;
  fullscreen: boolean;

  constructor(
    aberto: boolean,
    titulo: string,
    mensagem: string,
    largura?: string,
    tipo?: TipoModalEnum,
    fullscreen?: boolean
  ) {
    this.aberto = aberto;
    this.titulo = titulo;
    this.mensagem = mensagem;
    this.largura = largura || "400";
    this.tipo = tipo || TipoModalEnum.PADRAO;
    this.fullscreen = fullscreen || false;
  }

  static defaultValue() {
    return new DadosModal(false, "", "");
  }
}
